document.getElementById('toggle-nav').addEventListener('click', function() {
  var navContainer = document.getElementById('nav-container');
  navContainer.style.transform = 'translateY(0)'; // ナビゲーションバナーを表示
  this.style.display = 'none'; // 「詳細はこちら」ボタンを非表示に
});

document.getElementById('close-nav').addEventListener('click', function() {
  var navContainer = document.getElementById('nav-container');
  navContainer.style.transform = 'translateY(100%)'; // ナビゲーションバナーを非表示に
  document.getElementById('toggle-nav').style.display = 'block'; // 「詳細はこちら」ボタンを再表示
});

// ナビゲーションバナー以外の部分をクリックしたときにナビゲーションを閉じる
document.body.addEventListener('click', function(e) {
  var navContainer = document.getElementById('nav-container');
  var toggleNav = document.getElementById('toggle-nav');
  if (!navContainer.contains(e.target) && e.target !== toggleNav) {
    if (navContainer.style.transform === 'translateY(0px)') { // ナビゲーションバナーが表示されている場合のみ
      navContainer.style.transform = 'translateY(100%)';
      toggleNav.style.display = 'block'; // 「詳細はこちら」ボタンを再表示
    }
  }
}, true); // イベントキャプチャで処理



document.addEventListener('DOMContentLoaded', function() {
  // ページロード時に「詳細はこちら」ボタンを非表示に設定
  var toggleNav = document.getElementById('toggle-nav');
  toggleNav.style.display = 'none';

  // ページにアクセスして5秒後にボタンを表示
  setTimeout(function() {
    toggleNav.style.display = 'block';
  }, 3000); // 5000ミリ秒 = 5秒
});
